(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["icon-with-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('icon-content-expand')) {
    class IconContentExpand extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.icon-content-expand__content');
        this.button = this.querySelector('.icon-content-expand__button');

        if (!this.content || !this.button || this.initialized) return;

        this.initialized = true;
        this.button.addEventListener('click', () => this.toggle());
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.content);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      update() {
        const collapsedHeight = Number.parseFloat(getComputedStyle(this).getPropertyValue('--collapsed-height'));
        const isOverflowing = this.content.scrollHeight > collapsedHeight + 1;

        this.style.setProperty('--expanded-height', `${this.content.scrollHeight}px`);
        this.classList.toggle('icon-content-expand--no-overflow', !isOverflowing);
        this.content.inert = isOverflowing && !this.classList.contains('is-expanded');
      }

      toggle() {
        const isExpanded = this.classList.toggle('is-expanded');

        this.button.setAttribute('aria-expanded', String(isExpanded));
        this.content.inert = !isExpanded;
      }
    }

    customElements.define('icon-content-expand', IconContentExpand);
  }
  } catch(e) { console.error(e); }
})();

})();
